
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { galponesXGranja, startGalponXID, startListadoGalpones } from "../../../services";






export const useGalponXID = (id) => {

    const galponXIDQuery = useQuery({
        queryKey: ['galpon-id', id], 
        queryFn: () => startGalponXID(id),
    });

    return {
        galponXIDQuery
    }
}



export const useGalponesXGranja = (id) => {
    const galponesXGranjaQuery = useQuery({
        queryKey: ['galpones-xgranja', id], 
        queryFn: () => galponesXGranja(id),
        enabled: !!id,
    });

    return {
        galponesXGranjaQuery,
    }
}









export const useGalponesQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const galponesListQuery = useQuery({
        queryKey: ['galpones-list', { page, termino }], 
        queryFn: () => startListadoGalpones({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        galponesListQuery,
    }
}
